import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { CardStack } from "@shared/models/card-stack"
import type { Unit } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import copyLessonAction from "cc-frontend/lib/actions/lesson/LESSON_COPY"
import type Dispatcher from "cc-frontend/services/dispatcher"
import type ModalManager from "cc-frontend/services/modal-manager"
import type Session from "cc-frontend/services/session"

interface Args {
  unitCardStack: CardStack
  courseId: string
  closeMenu: Function
  unitInfo: Unit
  planbook: Planbook
}

export default class UnitMenuPrimaryReadOnly extends Component<Args> {
  @service modalManager!: ModalManager
  @service dispatcher!: Dispatcher
  @service session!: Session

  @action
  copyUnit() {
    this.args.closeMenu()

    if (this.session.isAuthenticated !== true) {
      this.session.mustSignInToProceed("Copy Lesson")
      return
    }

    if (this.session.userId !== null) {
      this.dispatcher.dispatchPreparedAction(
        copyLessonAction({
          lessonToCopy: this.args.unitCardStack,
          cardStackId: this.args.unitCardStack.id,
          currentUserId: this.session.userId,
          ownerIds: [this.args.planbook.relationships.owner.data.id],
          planbookId: this.args.planbook.id,
          courseId: this.args.courseId,
        })
      )
    }
  }

  @action
  printOrDownload() {
    this.modalManager.openModal("planner/modals/print-download", {
      courseId: this.args.courseId,
      planbookId: this.args.planbook.id,
      unitId: this.args.unitCardStack.id,
      startDate: this.args.unitInfo.startDate,
      endDate: this.args.unitInfo.endDate,
      layout: "course-unit",
      canPrint: true,
    })

    this.args.closeMenu()
  }
}
